import { render, staticRenderFns } from "./SearchCriteriaList.vue?vue&type=template&id=238e439c&scoped=true"
import script from "./SearchCriteriaList.vue?vue&type=script&lang=ts"
export * from "./SearchCriteriaList.vue?vue&type=script&lang=ts"
import style0 from "./SearchCriteriaList.vue?vue&type=style&index=0&id=238e439c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e439c",
  null
  
)

export default component.exports